import React from "react";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";

const basePositionStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 9999
};

const baseOverlayStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "black",
  opacity: 0.5
};

const baseContentStyle = theme => ({
  position: "fixed",
  left: "45%",
  top: "40vh",
  color: theme.palette.text.primary,
  textAlign: "center",
  verticalAlign: "middle",
  horizontalAlign: "middle",
  display: "table-cell",
  zIndex: 99999
});

const Overlay = React.memo(({
  content,
  positionStyle = {},
  overlayStyle = {},
  contentStyle = {}}) => {
  const {theme} = React.useContext(CustomThemeContext);
  return <div style={{...basePositionStyle, ...positionStyle}}>
    <div style={{...baseOverlayStyle, ...overlayStyle}} />
    <div style={{...baseContentStyle(theme), ...contentStyle}}>{content}</div>
  </div>
});

export default Overlay;

